import { Spacer } from "@aviary";
import { DiscoverEmerson } from "@clinic/emerson/scenes/HomePage/DiscoverEmerson/DiscoverEmerson";
import {
  type WordpressFeaturedItemType,
  useWordpressFeaturedItemsQuery,
  FeaturedBrandLocation,
} from "@emerson/data/queries/WordpressFeaturedItemsQuery/WordpressFeaturedItemsQuery.query";
import { BridgeBanner } from "@emerson/scenes/HomePage/BridgeBanner/BridgeBanner";
import { EducationalResources } from "@emerson/scenes/HomePage/EducationalResources/EducationalResources";
import { FeaturedBrands } from "@emerson/scenes/HomePage/FeaturedBrands/FeaturedBrands";
import { FeaturedProducts } from "@emerson/scenes/HomePage/FeaturedProducts/FeaturedProducts";
import { HomeCarousel } from "@emerson/scenes/HomePage/HomeCarousel/HomeCarousel";
import { InfoPillars } from "@emerson/scenes/HomePage/InfoPillars/InfoPillars";
import { Newsletter } from "@emerson/scenes/HomePage/Newsletter/Newsletter";
import { QualityProgram } from "@emerson/scenes/HomePage/QualityProgram/QualityProgram";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";
import { isE2E } from "@shared/utils/fullscriptEnv/fullscriptEnv";

const HomePage = () => {
  const { tablet } = useBreakpoints();

  const {
    loading: loadingBrands,
    error: featuredBrandsError,
    data: featuredBrands,
  } = useWordpressFeaturedItemsQuery({
    variables: { type: "brand" },
    skip: isE2E(),
  });

  const {
    loading: loadingProducts,
    error: featuredProductsError,
    data: featuredProducts,
  } = useWordpressFeaturedItemsQuery({
    variables: { type: "product" },
    skip: isE2E(),
  });

  let brands: WordpressFeaturedItemType[] = [];
  if (!loadingBrands && !featuredBrandsError) {
    brands =
      featuredBrands?.featuredItems?.nodes?.filter(
        node => node.featuredBrandLocation === FeaturedBrandLocation.home
      ) || [];
  }

  let productIds: string[] | undefined;
  if (!loadingProducts && !featuredProductsError) {
    productIds = featuredProducts?.featuredItems?.nodes?.reduce((acc, node) => {
      if (node.featuredProductId) {
        return [...acc, node.featuredProductId];
      }

      return acc;
    }, [] as string[]);
  }

  const renderSpacer = () => {
    if (tablet.greaterThan) {
      return (
        <>
          <Spacer height="doubleHalf" />
          <Spacer height="doubleHalf" />
        </>
      );
    }

    return <Spacer height="doubleHalf" />;
  };

  return (
    <section>
      <HomeCarousel />
      <Spacer height="oneHalf" />
      <BridgeBanner />
      <Spacer height="oneHalf" />
      <FeaturedBrands brands={brands} />
      <FeaturedProducts productIds={productIds} />
      {renderSpacer()}
      <DiscoverEmerson />
      {renderSpacer()}
      <EducationalResources />
      {renderSpacer()}
      <QualityProgram />
      {renderSpacer()}
      <InfoPillars />
      {renderSpacer()}
      <Newsletter />
    </section>
  );
};

export { HomePage };
